module.exports = __webpack_public_path__ + "img/ic_12_ranking_up.1eb86f78.svg";